(function () {
  function init() {
  const root = document.querySelector('.tb-section');
  if (!root || root.dataset.builderReady) return;
  root.dataset.builderReady = 'true';
  const MAX = Number(root.dataset.maxItems) || 10;
  const selected = {};
  const boxPriceLabel = root.dataset.boxPriceLabel || '';
  const boxAvailable = root.dataset.boxAvailable === 'true' && !!boxPriceLabel && !!root.dataset.boxVariantId;
  const addLabel = boxAvailable ? 'Add to cart, ' + boxPriceLabel : 'Sample box unavailable';
  const storefrontRoot = window.Shopify?.routes?.root || '/';

  const cardList = Array.from(root.querySelectorAll('.tb-card'));
  const cardInfo = new Map(cardList.map(card => [card, {
    tags: (card.dataset.tags || '').split(',').filter(Boolean),
    grades: (card.dataset.grade || '').split(',').filter(Boolean),
    title: (card.dataset.title || '').toLowerCase()
  }]));
  function getCards() { return cardList; }
  function shortLabel(t) {
    const clean = String(t).replace(/^Inspired by\s+/i, '').replace(/^[^,]+,\s*/, '');
    return clean.length > 13 ? clean.slice(0, 12) + '…' : clean;
  }

  function updateUI() {
    const count = Object.keys(selected).length;
    document.getElementById('tb-count').textContent = count;
    document.getElementById('tb-progress-fill').style.width = ((count / MAX) * 100) + '%';
    const btn = document.getElementById('tb-checkout-btn');
    const txt = document.getElementById('tb-btn-text');
    btn.disabled = count !== MAX || !boxAvailable;
    txt.textContent = !boxAvailable ? addLabel : count === MAX ? addLabel
      : (count === 0 ? 'Pick ' + MAX + ' to continue' : (MAX - count) + ' more to go');
    document.getElementById('tb-clear-box').hidden = count === 0;
    const atLimit = count >= MAX;
    getCards().forEach(card => {
      card.classList.toggle('tb-at-limit', atLimit && !selected[card.dataset.productId]);
    });
  }

  function fillSlot(n, title, pid) {
    const s = document.getElementById('tb-vial-' + n); if (!s) return;
    s.classList.add('filled'); s.dataset.productId = pid;
    const l = s.querySelector('.tb-vial-slot__label'); l.textContent = shortLabel(title); l.title = title;
  }
  function emptySlot(n) {
    const s = document.getElementById('tb-vial-' + n); if (!s) return;
    s.classList.remove('filled'); delete s.dataset.productId;
    const l = s.querySelector('.tb-vial-slot__label'); l.textContent = ''; l.removeAttribute('title');
  }
  function resequence() {
    const e = Object.entries(selected).sort((a,b)=>a[1].slot-b[1].slot);
    for (let i=1;i<=MAX;i++) emptySlot(i);
    e.forEach(([pid,d],i)=>{ selected[pid].slot=i+1; fillSlot(i+1,d.title,pid); });
  }

  function selectProduct(card) {
    const pid = card.dataset.productId;
    if (selected[pid] || Object.keys(selected).length >= MAX) return;
    selected[pid] = { title: card.dataset.title, variantId: card.dataset.variantId, variantTitle: card.dataset.variantTitle, slot: Object.keys(selected).length + 1 };
    card.querySelector('.tb-sample-grade').disabled = true;
    fillSlot(selected[pid].slot, card.dataset.title, pid);
    card.classList.add('tb-selected');
    const b = card.querySelector('.tb-add-btn'); if (b) b.textContent = 'Remove';
  }
  function deselectProduct(card) {
    const pid = card.dataset.productId;
    if (!selected[pid]) return;
    delete selected[pid];
    card.querySelector('.tb-sample-grade').disabled = false;
    card.classList.remove('tb-selected');
    const b = card.querySelector('.tb-add-btn'); if (b) b.textContent = 'Add to box';
    resequence();
  }
  function toggleProduct(btn) {
    const card = btn.closest('.tb-card');
    if (selected[card.dataset.productId]) deselectProduct(card); else selectProduct(card);
    updateUI();
  }
  function removeBySlot(n) {
    const s = document.getElementById('tb-vial-' + n);
    const pid = s ? s.dataset.productId : null;
    if (!pid) return;
    const card = document.querySelector('.tb-card[data-product-id="' + pid + '"]');
    if (card) deselectProduct(card); else { delete selected[pid]; resequence(); }
    updateUI();
  }

  function autofill() {
    Object.keys(selected).forEach(pid => {
      const c = document.querySelector('.tb-card[data-product-id="' + pid + '"]');
      if (c) deselectProduct(c);
    });
    const best = [...getCards()].filter(c => c.dataset.best === '1').slice(0, MAX);
    best.forEach(c => selectProduct(c));
    updateUI();
    document.getElementById('tb-box-panel').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
  function clearBox() {
    Object.keys(selected).forEach(pid => {
      const c = document.querySelector('.tb-card[data-product-id="' + pid + '"]');
      if (c) deselectProduct(c); else delete selected[pid];
    });
    resequence(); updateUI();
  }

  function applyFilters() {
    const g = q => [...document.querySelectorAll('[data-group="'+q+'"]:checked')].map(c=>c.dataset.value);
    const genderVals=g('gender'), gradeVals=g('grade'), brandVals=g('brand'), familyVals=g('family'), bestVals=g('best');
    const seasonVals=g('season'), occasionVals=g('occasion'), longevityVals=g('longevity');
    const search = (document.getElementById('tb-search')?.value||'').trim().toLowerCase();
    let visible = 0;
    getCards().forEach(card => {
      const { tags, grades, title } = cardInfo.get(card);
      const ok = (genderVals.length===0 || genderVals.some(v=>tags.includes(v)))
        && (gradeVals.length===0 || gradeVals.some(v=>grades.includes(v)))
        && (brandVals.length===0 || brandVals.some(v=>title.includes(v)))
        && (familyVals.length===0 || familyVals.some(v=>tags.includes(v)))
        && (bestVals.length===0 || card.dataset.best==='1')
        && (seasonVals.length===0 || seasonVals.some(v=>tags.includes(v)))
        && (occasionVals.length===0 || occasionVals.some(v=>tags.includes(v)))
        && (longevityVals.length===0 || longevityVals.some(v=>tags.includes(v)))
        && (search==='' || title.includes(search));
      card.classList.toggle('tb-hidden', !ok);
      if (ok) visible++;
    });
    document.getElementById('tb-showing').textContent = visible;
    document.getElementById('tb-no-results').classList.toggle('hidden', visible>0);
  }

  function applySort() {
    const mode = document.getElementById('tb-sort').value;
    const grid = document.getElementById('tb-grid');
    const cards = [...getCards()];
    cards.sort((a,b)=>{
      if (mode==='az') return a.dataset.title.localeCompare(b.dataset.title);
      if (mode==='best') return (b.dataset.best|0)-(a.dataset.best|0) || a.dataset.title.localeCompare(b.dataset.title);
      return 0;
    });
    const fragment = document.createDocumentFragment();
    // The cached list preserves the original featured order when switching back.
    cards.forEach(card => fragment.appendChild(card));
    grid.appendChild(fragment);
  }

  /* Add the box exactly like the product page's Add to cart does (theme cart.js / product form):
     one line item, the market-priced "Aroma Labs Tester Box" variant, with the 10 picks saved as line
     properties. No discount codes, so the price is always right in every currency. */
  const BOX_VARIANT_ID = Number(root.dataset.boxVariantId);

  function sectionsToRender() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
    );
    return [...new Set(sections.filter(Boolean))];
  }

  async function addToCart() {
    const btn = document.getElementById('tb-checkout-btn');
    const txt = document.getElementById('tb-btn-text');
    const errorEl = document.getElementById('tb-cart-error');
    if (Object.keys(selected).length !== MAX || !boxAvailable) return;
    btn.disabled = true; txt.textContent = 'Adding…';
    if (errorEl) errorEl.textContent = '';

    const theme = window.FoxTheme;
    const drawer = document.querySelector('cart-drawer');
    const useDrawer = !!(theme && theme.pubsub && drawer && theme.settings && theme.settings.cartType === 'drawer'
      && !document.body.classList.contains('cart-template'));

    const samples = Object.values(selected).sort((a, b) => a.slot - b.slot);
    const properties = {};
    samples.forEach((s, i) => {
      const grade = (s.variantTitle || '').split(' / ')[0];
      properties['Sample ' + (i + 1)] = s.title + (grade ? ' (' + grade + ')' : '');
    });
    properties['_sample_variant_ids'] = samples.map(s => s.variantId).join(',');

    const sections = useDrawer ? sectionsToRender() : [];
    const body = { items: [{ id: BOX_VARIANT_ID, quantity: 1, properties }] };
    if (sections.length) { body.sections = sections; body.sections_url = window.location.pathname; }

    try {
      const res = await fetch(storefrontRoot + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      });
      const added = await res.json();
      if (!res.ok || added.status) throw new Error(added.description || added.message || 'Could not add the box. Please try again.');

      clearBox();
      btn.disabled = true; txt.textContent = 'Added to cart ✓';

      if (!useDrawer) { window.location.href = storefrontRoot + 'cart'; return; }

      const cartJson = await (await fetch(storefrontRoot + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      cartJson.sections = added.sections;
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', cart: cartJson });
      document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: added } }));
      try { if (typeof drawer.onCartRefresh === 'function') await drawer.onCartRefresh({ detail: { open: false } }); } catch (_) {}
      if (!drawer.open) drawer.show(btn);
      setTimeout(updateUI, 2500);
    } catch (e) {
      updateUI();
      if (errorEl) errorEl.textContent = e.message || 'Could not add the box. Please try again.';
    }
  }

  function toggleGroup(t) {
    const ex = t.getAttribute('aria-expanded')==='true';
    t.setAttribute('aria-expanded', !ex);
    t.nextElementSibling.classList.toggle('collapsed', ex);
  }
  function clearFilters() {
    document.querySelectorAll('.tb-filter-check').forEach(c=>c.checked=false);
    const s=document.getElementById('tb-search'); if(s) s.value='';
    applyFilters();
  }

  function bind() {
    document.querySelectorAll('.tb-add-btn').forEach(b=>b.addEventListener('click',function(){toggleProduct(this);}));
    document.querySelectorAll('.tb-sample-grade').forEach(select=>select.addEventListener('change',function(){ const card=this.closest('.tb-card'); card.dataset.variantId=this.value; card.dataset.variantTitle=this.options[this.selectedIndex].dataset.variantTitle; }));
    document.querySelectorAll('.tb-filter-check').forEach(c=>c.addEventListener('change',applyFilters));
    let searchFrame = 0;
    document.getElementById('tb-search')?.addEventListener('input', function () {
      if (searchFrame) return;
      searchFrame = requestAnimationFrame(function () { searchFrame = 0; applyFilters(); });
    });
    document.getElementById('tb-sort')?.addEventListener('change',applySort);
    document.getElementById('tb-autofill')?.addEventListener('click',autofill);
    document.getElementById('tb-clear-box')?.addEventListener('click',clearBox);
    document.getElementById('tb-checkout-btn')?.addEventListener('click',addToCart);
    document.querySelectorAll('.tb-vial-slot__remove').forEach(b=>b.addEventListener('click',function(){removeBySlot(parseInt(this.closest('.tb-vial-slot').dataset.slot));}));
    document.getElementById('tb-showing').textContent = getCards().length;
    updateUI();
  }
  bind();

  window.tbToggleGroup = toggleGroup;
  window.tbClearFilters = clearFilters;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

/* Mobile: pin only the test-tube tray. The box card sticks with a negative top equal to the
   height of everything above the tray, so just the tray (plus a thin margin) stays on screen. */
(function () {
  function setupTrayStick() {
    var panel = document.getElementById('tb-box-panel');
    if (!panel || panel.dataset.trayStick) return;
    var tray = panel.querySelector('.tb-box-tray');
    if (!tray) return;
    panel.dataset.trayStick = '1';
    var mq = window.matchMedia('(max-width: 860px)');
    function measure() {
      if (!mq.matches) { panel.style.removeProperty('--tb-stick'); return; }
      panel.style.setProperty('--tb-stick', (8 - tray.offsetTop) + 'px');
    }
    if (window.ResizeObserver) new ResizeObserver(measure).observe(panel);
    window.addEventListener('resize', measure);
    if (mq.addEventListener) mq.addEventListener('change', measure);
    measure();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupTrayStick, { once: true });
  else setupTrayStick();
  document.addEventListener('shopify:section:load', setupTrayStick);
})();
